import React from "react";
import { useAppContext } from "../providers/AppProvider";
import { useNavigate, useNavigation } from "react-router-dom";
import { request } from "../api/useApi";
import { toast } from "react-toastify";

export default function useCalculator() {
  const { loading, setLoading } = useAppContext();
  const navigate = useNavigate();

  const getReport = async (form: any) => {
    setLoading((loading) => ({
      ...loading,
      isLoading: true,
    }));
    try {
      setLoading((loading) => ({ ...loading, progress: 50 }));
      const { data } = await request.post<{
        success: boolean;
        error: any;
        payload: { savings: string };
      }>("/calculator/getemissionreport", form);
      console.log(data);
      await new Promise((resolve) => setTimeout(resolve, 2000));
      if (data.error) {
        toast.error(data.error || "An error occured");
        return;
      }
      navigate("/carbonimpact?savings=" + data.payload.savings);
      return data;
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred!");
    } finally {
      // Reset loading state
      setLoading((loading) => ({
        ...loading,
        isLoading: false,
        progress: 0,
      }));
    }
  };

  const getprompt = async (distance: string) => {
    try {
      const { data } = await request.get(`prompt?distance=${distance}`);
      return data.data;
    } catch (error) {
      console.error(error);
    }
  };
  const getSavingsPrompt = async (savings: string) => {
    try {
      const { data } = await request.get(`prompt/savings?savings=${savings}`);
      return data.data;
    } catch (error) {
      console.error(error);
    }
  };
  return {
    getReport,
    getprompt,
    getSavingsPrompt,
    loading,
  };
}
